// The day bar of the Encaissement sheets — the Planning board's own
// (reception team/DayView), so the desk moves between days the same way
// everywhere: ‹ date › · the day in words · « Demain » · « Aujourd'hui ».
// `FrDateInput` is the board's input too: it shows dd/mm/yyyy whatever the
// machine's locale.

import { FrDateInput } from '@lemontaigu/reception/ui/FrDateInput.js';
import type { IsoDate } from '@lemontaigu/pms-core';
import { fmtDayLabel, shiftDay } from './departureSheet.js';

export interface DayBarProps {
  value: IsoDate;
  onChange: (day: IsoDate) => void;
  /** The hotel's today — for « Aujourd'hui » and « Demain ». */
  today: IsoDate;
  /** The date field's accessible name (« Date de départ »…). */
  label: string;
}

export function DayBar({ value, onChange, today, label }: DayBarProps) {
  const tomorrow = shiftDay(today, 1);
  return (
    <div className="pms-daybar pms-no-print">
      <button type="button" onClick={() => onChange(shiftDay(value, -1))} aria-label="Jour précédent">
        ‹
      </button>
      <FrDateInput
        className="pms-datepicker"
        value={value}
        aria-label={label}
        onChange={(v) => v && onChange(v as IsoDate)}
      />
      <button type="button" onClick={() => onChange(shiftDay(value, 1))} aria-label="Jour suivant">
        ›
      </button>
      <span className="pms-daylabel">{fmtDayLabel(value)}</span>
      {value !== tomorrow && (
        <button type="button" className="pms-daybar-jump" onClick={() => onChange(tomorrow)}>
          Demain
        </button>
      )}
      {value !== today && (
        <button type="button" className="pms-daybar-jump" onClick={() => onChange(today)}>
          Aujourd’hui
        </button>
      )}
    </div>
  );
}
